module.exports = "/assets/data/1788fb3c1127ff3e5ec85682ad725693-LA3.data.json";